import React from 'react';
import { cn } from "../../shared/utils/cn";
import { STATUS_VARIANT_CLASSES } from "../../utils/statusColors";

interface BadgeProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: 'default' | 'success' | 'warning' | 'danger' | 'info' | 'slate';
  size?: 'sm' | 'md' | 'lg';
}

const Badge = React.forwardRef<HTMLDivElement, BadgeProps>(
  ({ className, variant = 'default', size = 'md', ...props }, ref) => {
    // Map Badge's semantic variants to the canonical status palette so every
    // status chip (Badge + StatusChip + schedule chips) shares one palette.
    const variants = {
      default: STATUS_VARIANT_CLASSES.gray,
      success: STATUS_VARIANT_CLASSES.green,
      warning: STATUS_VARIANT_CLASSES.yellow,
      danger:  STATUS_VARIANT_CLASSES.red,
      info:    STATUS_VARIANT_CLASSES.blue,
      slate:   STATUS_VARIANT_CLASSES.slate, // TERMINATED — distinct from gray/CLOSED
    };

    const sizes = {
      sm: "text-xs px-2 py-0.5",
      md: "text-sm px-2.5 py-0.5",
      lg: "text-base px-3 py-1",
    };

    return (
      <div
        ref={ref}
        className={cn(
          "inline-flex items-center font-medium rounded-full",
          variants[variant],
          sizes[size],
          className
        )}
        {...props}
      />
    );
  }
);

Badge.displayName = 'Badge';

export default Badge;